import React, { useState } from 'react';
import Styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Applet, { AppletContainer } from '../../Components/Applet';
import WelcomeToDavie from '../../Components/WelcomeToDavie';
import usePost from '../../Hooks/usePost';
import { StyledButton } from '../../Components/Generics.styled';

const LoginContainer = Styled.div`
margin-top: 100px;
width: 100%;
margin-bottom: 100px;
height: 800px;
`;

const FormName = Styled.div`
text-align: left;
letter-spacing: 0.77px;
color: #000000DE;
opacity: 1;
padding-left: 15px;
padding-top: 11px;
`;

const LoginTextFieldContainer = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 25px;
  margin-left: 15px;
  margin-right: 15px;
`;

const LoginButton = Styled(Button)`
background: #2e69fe 0% 0% no-repeat padding-box !important;
box-shadow: 0px 3px 3px #00000061;
border-radius: 4px;
opacity: 1;
width: 100%;

    &.MuiButton-contained.Mui-disabled {
    color: #fafbf7;
  }
  :disabled {
    background: #9b9b9d 0% 0% no-repeat padding-box !important;
  }
`;

const CreateAccountLink = Styled(Link)`
text-align: center;
color: #0000EE;
`;

const ForgotPasswordLink = Styled(Link)`
color: #3F51B5;
text-align: center;
color: #0000EE;



`;

const ForgotPassword = () => {
    const [postData, setPostData] = useState({
        error: false,
        isLoading: false,
        success: false,
        message: [],
    });

    const [email, setEmail] = useState('');

    const { post } = usePost('/forgotPassword');

    const handleChange = (e) => {
        setPostData({
            error: false,
            isLoading: false,
            success: false,
            message: [],
        });
        setEmail(e.target.value);
    };

    const handleResetPasswordButton = async () => {
        try {
            setPostData({ ...postData, isLoading: true });
            const forgotPasswordResp = await post(
                {
                    userName: email,
                    baseUrl: process.env.REACT_APP_API_ACCOUNT_MANAGEMENT_RESET_PASSWORD,
                },
                'POST'
            );

            if (forgotPasswordResp.data.userName === null) {
                setPostData({
                    ...postData,
                    message: ['Account does not exist or email is incorrect.'],
                    isLoading: false,
                    error: true,
                });
            } else {
                setPostData({
                    ...postData,
                    message: ['Password reset email sent!'],
                    isLoading: false,
                    error: false,
                });
            }
        } catch (error) {
            setPostData({
                message: ['Something went wrong, please try again later.'],
                isLoading: false,
                success: false,
                error: true,
            });
        }
    };

    const strongEmailRegex =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const emailIsNotValidFormat = !email.match(strongEmailRegex);

    const buttonIsDisabled = emailIsNotValidFormat;

    return (
        <LoginContainer>
            <WelcomeToDavie />
            <AppletContainer>
                <Applet>
                    <FormName>Forgot Password</FormName>
                    <LoginTextFieldContainer>
                        <TextField
                            id="email-login"
                            label="Email Address"
                            defaultValue={email}
                            onChange={(e) => handleChange(e)}
                            error={emailIsNotValidFormat}
                            helperText={
                                emailIsNotValidFormat
                                    ? 'Email must be in valid format. Example test@test.com.'
                                    : ''
                            }
                            variant="outlined"
                            required
                        />
                        <br />
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <StyledButton
                                onClick={() => handleResetPasswordButton()}
                                variant="contained"
                                color="primary"
                                disabled={buttonIsDisabled}
                            >
                                Send Reset Email
                            </StyledButton>
                        </div>
                        <br />

                        {
                            <div
                                style={{
                                    marginTop: '8px',
                                    marginBottom: '8px',
                                    color: postData.error ? 'red' : 'green',
                                    fontSize: '13px',
                                }}
                            >
                                {postData.message && postData.message.length > 1
                                    ? postData.message.map((item, idx) => (
                                          <div key={idx}>{item}</div>
                                      ))
                                    : postData.message}
                            </div>
                        }
                        <ForgotPasswordLink to="/login">Login</ForgotPasswordLink>
                        <div
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                paddingTop: '8px',
                                paddingBottom: '8px',
                            }}
                        >
                            Or
                        </div>
                        <CreateAccountLink to="/signup">Sign Up Now</CreateAccountLink>
                        <br />
                    </LoginTextFieldContainer>
                </Applet>
            </AppletContainer>
        </LoginContainer>
    );
};

export default ForgotPassword;
